/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-07-08 17:22:19
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-24 14:47:25
 */
export const ORDERSTATUS = {
  1: '待处理',
  2: '生产中',
  3: '作废',
  4: '质检未通过',
  5: '已发货',
  6: '已完成',
  7: '已转为补发订单',
  8: '已转为异常订单',
  9: '已转为返修订单',
  10: '搁置订单',
  11: '未分配工厂',
  12: '已分配工厂',
};

export const OrderPlatform = {
  shopify: 'shopify',
  shopline: 'shopline',
};

export const OrderType = {
  normal: '普通流程订单',
  repair: '返修流程订单',
  reissue: '补发流程订单',
};

export const bearerEnum = {
  1: '工厂',
  2: '公司',
  3: '物流公司',
};

export const RoleEnum = {
  admin: '管理员',
  factory: '工厂',
  supplier: '供应链',
  finance: '财务',
  operation: '运营',
};
